import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { InputComponent } from "../../../shared/components/forms/input/input.component";
import { CheckboxComponent } from "../../../shared/components/forms/checkbox/checkbox.component";
import { NavigationService } from '@app/services/navigation/navigation.service';
import { BetInputListComponent } from "../bet-input-list/bet-input-list.component";
import { Toaster } from '@app/services/toaster/toaster.service';
import { ListsService } from '../lists.service';
import { ListsApi } from '../lists.api';
import { AppService } from '@app/services/app.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { RECAPTCHA_LANGUAGE, RECAPTCHA_LOADER_OPTIONS, RecaptchaModule } from 'ng-recaptcha';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-list-form',
	standalone: true,
	imports: [
		SharedModule,
		InputComponent,
		BetInputListComponent,
		CheckboxComponent,
		RecaptchaModule,
	],
	providers: [
		ListsService,
		ListsApi,
	],
	templateUrl: './list-form.component.html',
	styleUrl: './list-form.component.scss'
})
export class ListFormComponent implements OnInit {
	@Output() submit: EventEmitter<any> = new EventEmitter<any>();
	@Input() loading: boolean = false;
	public captchaKey: string = environment.recaptcha;
	public isMobile: boolean = true;
	public dev: boolean = false;
	public name?: string;
	public email?: string;
	public city?: string;
	public state?: string;
	public accept: boolean = false;
	public captcha: boolean = false;
	public captchaResponse?: string;
	public list: string[] = [];
	public qttNames: number = 15;

	constructor(
		private appService: AppService,
		private settings: SettingsService,
		private nav: NavigationService,
		private toast: Toaster,
		private service: ListsService,
	) { }

	ngOnInit(): void {
		this.Initialize();
	}

	public Initialize() {
		this.isMobile = this.appService.mobileOn();
		this.settings.isDev().then(d => this.dev = d);
	}

	public goTermos = () => this.nav.goTerms();

	public getAmountNames(): number {
		const names = this.list.filter(n => n);
		return names.length;
	}
	public validateEmail(): boolean {
		return !!this.email;
	}
	public validate(): boolean {
		let valid = true;
		const setError = (msg: string) => {
			this.toast.error(msg);
			valid = false;
		}
		if (!this.accept) setError("Você deve concordar com os termos de uso!");
		if (!this.name) setError("Nome deve ser preenchido!");
		if (!this.validateEmail()) setError("Necessário preencher um e-mail válido!");
		if (!this.city || !this.state) setError("Necessário preencher sua localização!");
		const names = this.getAmountNames();
		if (names < this.qttNames) {
			this.toast.error(`${this.qttNames} nomes são necessários!\n(${names} enviados)`);
			return false;
		}
		if (!this.captcha) {
			this.toast.error("Erro na validação de captcha!");
			return false;
		}
		return valid;
	}
	public cantSendRs(): string | null {
		const l = this.getAmountNames();
		if (l == this.qttNames) return null;
		if (l == 0) return `Preencha ${this.qttNames} nomes!`;
		return `${l}/${this.qttNames} nomes preenchidos`;
	}

	public register(): boolean {
		if (!this.validate()) return false;
		this.submit.emit({
			name: this.name,
			email: this.email,
			city: this.city,
			state: this.state,
			list: this.list,
			captcha: this.captchaResponse,
		});
		return true;
	}

	public fillUpTest() {
		const rand = Math.random() * (9999 - 1111) + 1111;
		this.name = `Test user ${rand}`;
		this.email = `test${rand}@paulovelho.com`;
		this.city = `testcity`;
		this.state = `teststate`;
		this.list = this.service.giveMeNames();
	}

	public captchaResolve(data:any) {
		this.captchaResponse = data;
		this.captcha = true;
	}

}
